import { Resolver, Query, Ctx } from 'type-graphql'
import { ScalarObject } from '@things-factory/shell'
import { analyzeBoardIntegration } from '../../controllers/analyzer/analyze-integration.js'

@Resolver()
export class IntegrationAnalysisQuery {
  @Query(returns => ScalarObject, { description: 'To fetch integration Analyses' })
  async integrationAnalysis(@Ctx() context: ResolverContext): Promise<any> {
    const { domain } = context.state

    return await analyzeBoardIntegration(domain)
  }
}
